// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1z-DG","modalFooterButton":"ModalNotes_modalFooterButton__3wTNB"};